export const getStatusBadgeColor = (statusCode: string) => {
  const code = parseInt(statusCode);
  if (code >= 400) {
    return 'bg-red-500 text-white';
  }
  if (code >= 300) {
    return 'bg-blue-500 text-white';
  }
  if (code >= 200) {
    return 'bg-green-500 text-white';
  }
  return 'bg-gray-500 text-white';
};

export const getStatusTextColor = (statusCode: string) => {
  const code = parseInt(statusCode);

  if (code >= 400) {
    return 'text-red-600 dark:text-red-400';
  }
  if (code >= 300) {
    return 'text-blue-600 dark:text-blue-400';
  }
  if (code >= 200) {
    return 'text-green-600 dark:text-green-400';
  }
  return 'text-gray-600 dark:text-gray-400';
};

export const getMethodColor = (method: string) => {
  switch (method) {
    case 'GET':
      return 'text-blue-700 bg-blue-50 border-blue-200';
    case 'POST':
      return 'text-green-700 bg-green-50 border-green-200';
    case 'PUT':
      return 'text-orange-700 bg-orange-50 border-orange-200';
    case 'DELETE':
      return 'text-red-700 bg-red-50 border-red-200';
    case 'PATCH':
      return 'text-purple-700 bg-purple-50 border-purple-200';
    default:
      return 'text-gray-700 bg-gray-50 border-gray-200';
  }
};

export const getLevelFromStatus = (statusCode: number) => {
  if (statusCode >= 500) {
    return 'ERROR';
  }
  if (statusCode >= 400) {
    return 'ERROR';
  }
  if (statusCode >= 300) {
    return 'INFO';
  }
  if (statusCode >= 200) {
    return 'SUCCESS';
  }
  return 'INFO';
};
